const FEATURES = {
  bookmarks: false,
  defaultBookmarks: false,
  networkCheck: false,
  cmsBanner: false,
};

export default FEATURES;
